import React, { useRef, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import MuteOn from '@/assets/icons/categoryPage/MuteOn.svg';
import MuteOff from '@/assets/icons/categoryPage/MuteOff.svg';
import Image from 'next/image';

const VideoComponent = ({ url }: { url: string }) => {
  const [isInView, setIsInView] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5, // Adjust this threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setIsInView(entry.isIntersecting);
      });
    }, options);

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  const handleMuteToggle = () => {
    setIsMuted(!isMuted);
  };

  const handleTouchStart = (event: { preventDefault: () => void }) => {
    // Prevent scrolling when the user touches the video component
    event.preventDefault();
  };

  return (
    <div ref={videoRef} className="relative w-full h-full" onTouchStart={handleTouchStart}>
      <div className="player-wrapper-for-category-page w-full h-full">
        <ReactPlayer
          className="react-player-for-category-page w-full"
          playsinline
          url={url}
          width="100%"
          height="100%"
          playing={isInView}
          muted={isMuted || !isInView}
          controls={false}
          loop
          config={{
            file: {
              attributes: {
                playsinline: true,
                autoplay: true, // Autoplay the video
                muted: true,
              },
            },
          }}
        />
      </div>
      <div>
        <button type="button" onClick={handleMuteToggle} className="absolute top-5 right-5">
          {isMuted ? <Image src={MuteOff} alt="MuteOff" /> : <Image src={MuteOn} alt="MuteOn" />}
        </button>
      </div>
    </div>
  );
};

export default VideoComponent;
